const calculateCommission = (
    collected = null,
    hard_cost = 0,
    commision = null
) => {
    if (collected > 0 && hard_cost >= 0 && commision > 0) {
        const result =
            Number((collected - hard_cost) * commision).toFixed(2) / 100;

        return result <= 0 ? 0 : result;
    }
    return 0;
};

export default calculateCommission;
